export default __webpack_public_path__ + "static/media/claim_Form.8ac2ac5c.pdf";